import { render } from "./GuideView.vue?vue&type=template&id=2a24f4ca&scoped=true"
import script from "./GuideView.vue?vue&type=script&lang=js"
export * from "./GuideView.vue?vue&type=script&lang=js"

import "../assets/css/common.css?vue&type=style&index=0&lang=css"
import "../assets/css/Guide.css?vue&type=style&index=1&id=2a24f4ca&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\national-museum-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a24f4ca"]])

export default __exports__